import Vue from 'vue'
import VueRouter from 'vue-router'
import paths from './paths'
// import store from '../store/index'

Vue.use(VueRouter)

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
const router = new VueRouter({
  mode: 'history',
  base: '/Website/',
  routes: paths.concat([{
    path: '*',
    redirect: ''
  }]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  // store.commit('user/fetchSession')
  // const needAuth = ['/offers']
  // if (needAuth.includes(to.path)) {
  //   store.dispatch('setToken')
  // }
  // store.dispatch('setToken')
  // Check if the route is the "not found" page
  // const isNotFound = to.name === 'NotFound'
  //
  // // Hide some components on the "not found" page
  // const visible = !isNotFound
  //
  // // Pass the `sidebarVisible` prop to the router view
  // to.meta.sidebarVisible = sidebarVisible
  const paths = ['/profile', '/call-forward', '/super-clip']
  if (paths.includes(to.path)) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next('/home')
    }
  } else {
    next()
  }
})

export default router
